<template>
    <div class="app-box-input" :class="{ 'has-error': error, simple: simple }">
        <div
            class="box-input-wrap"
            :style="boxInputStyle"
            :class="{ small: small }"
        >
            <input
                :type="type"
                v-model="newValue"
                :id="label"
                :autofocus="autofocus"
                :disabled="disabled || loading"
                :placeholder="placeholderTrans"
                @focus="$emit('focus', $event)"
                @blur="$emit('blur', $event)"
                @input="onInput"
            />

            <div class="loader" v-if="loading" v-html="$icon('loader')"></div>
        </div>

        <span class="line"></span>

        <p class="message" :class="{ small: small }" v-if="message">
            {{ message }}
        </p>
    </div>
</template>

<script>
export default {
    name: "app-box-input",

    props: {
        type: {
            type: String,
            default: "text"
        },
        value: [String, Number],
        label: String,
        placeholder: String,
        width: String | null,
        error: Boolean,
        message: String,
        autofocus: Boolean,
        small: Boolean,
        licenseYear: Boolean,
        loading: false,
        simple: false,
        disabled: false,
        full: false
    },

    data() {
        return {
            newValue: this.value,
            focused: false
        };
    },

    watch: {
        value() {
            if (this.licenseYear && this.value.toString().length >= 4) {
                this.newValue = this.value.slice(0, 4);
            } else this.newValue = this.value;
            if (this.type === "number" && this.value < 0) {
                this.newValue = Math.abs(this.newValue);
            }
        }
    },

    methods: {
        onInput() {
            this.$emit("input", this.newValue);
            this.$emit("change", this.newValue);
        }
        // validateYear() {
        //     if (this.licenseYear) {
        //         // Assuming a valid year is between 1900 and the current year
        //         const validYearRegex = /^(19[0-9]\d|20[0-1]\d|202[0-2])$/;
        //         this.invalidYear = !validYearRegex.test(this.newValue);

        //         if (this.invalidYear) {
        //             this.newValue = this.newValue.slice(0, -1); // Remove the last character if it's invalid
        //         } else {
        //             this.onInput();
        //         }
        //     } else {
        //         this.onInput();
        //     }
        // }
    },

    computed: {
        filled() {
            return this.newValue || this.focused;
        },

        placeholderTrans() {
            return this.placeholder ? this.$trans(this.placeholder) : "";
        },

        boxInputStyle() {
            if (this.small || this.full) {
                return {};
            }

            return {
                width: this.width ? this.width + "px" : "206px"
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.app-box-input {
    display: block;
    position: relative;

    &.simple {
        .box-input-wrap {
            border: none;
            border-bottom: 1px solid $medium-gray;

            input {
                &:focus {
                    border: none;
                    border-bottom: solid 1px $primary-blue;
                }
            }
        }
    }

    .box-input-wrap {
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.small {
            height: 60px;

            input {
                font-size: 19px;
            }
        }

        @media all and (max-width: $mobile) {
            height: auto;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input {
        position: relative;
        z-index: 1;
        display: block;
        width: 100%;
        outline: none;
        height: 100%;
        font-size: 30px;
        font-weight: $font-bold;
        line-height: 1.32;
        color: $black;
        transition: color 0.2s ease-in-out, border 0.2s ease-in-out;

        border-radius: 100px;
        border: 1px solid rgba(33, 67, 146, 0.2);
        padding-right: 30px;

        @media all and (max-width: $mobile) {
            padding: 10px 30px;
            font-size: 21px;
        }

        &::placeholder {
            color: $black;
            font-weight: $font-light;
        }

        &:focus {
            color: $primary-blue;
            border: solid 1px $primary-blue;
        }
    }

    .loader {
        position: absolute;
        width: 1em;
        height: 1em;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;

        ::v-deep svg {
            stroke: black;
        }
    }

    .line {
        position: absolute;
        display: block;
        left: 50%;
        width: 0;
        bottom: -1px;
        height: 1px;
        z-index: 3;
        transform: translateX(-50%);
        background-color: $primary-blue;
        transition: all 0.4s ease-in-out;
    }

    .message {
        font-size: 1rem;
        margin: 10px 0 0;
        color: $error-red;
        font-weight: $font-normal;
    }
}
</style>
